export default [
  {
    path: '/system',
    name: 'system',
    component: r => require(['views/layout/Main'], r),
    redirect: '/system/list',
    children: [
      {
        path: 'list',
        name: 'system-list',
        component: r => require(['views/system/Main'], r)
      },
      {
        path: 'form',
        name: 'system-form',
        component: r => require(['views/system/children/Form'], r)
      },
      {
        path: 'relationship/:systemId',
        name: 'system-relationship',
        component: r => require(['views/system/children/Relationship'], r)
      }
    ]
  }
]
